import { init } from 'ityped';
import React, { useEffect, useRef } from 'react';
import { faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

function HomePage() {
    const textRef = useRef();
    useEffect(() => {
        init(textRef.current, {
            showCursor: true,
            backDelay: 1500,
            backSpeed: 60,
            strings: ["Software Engineer", "Filmmaker","Designer"],
        });
    }, []);
    return (
        <div className="HomePage">
            <header className="hero">
                <h1 className="hero-text">
                    Hi, I am
                    <span> Mainul Islam Fahim</span>
                </h1>
                <h3 className="text-center">
                    <span ref={textRef}></span>
                </h3>
                <p className="h-sub-text">
                    "You can't create reality in memories 
                    <br />
                    but you can create memories in reality" 
                </p>

                <div className="icons">
                    <a href="https://www.linkedin.com/in/mainul-islam-fahim-985bb11ba/" className="icon-holder">
                        <FontAwesomeIcon icon={faLinkedin} className="icon fb" />
                    </a>
                    <a href="https://github.com/Mainul-Fahim" className="icon-holder">
                        <FontAwesomeIcon icon={faGithub} className="icon gh" />
                    </a>
                    <a href="https://www.youtube.com/channel/UCjdjRus3ngd4Qk-u43r6G6g" className="icon-holder">
                        <FontAwesomeIcon icon={faYoutube} className="icon yt" />
                    </a>

                </div>
                <div className="text-center icons">
                    <h4>Download Resume</h4>
                    <br />
                    {/* <a href="https://drive.google.com/uc?export=download&id=16R-LLRav7m_kYCV3xYi2DVwnOYsggRHV"> <FontAwesomeIcon icon={faDownload} className="icon yt m-2" /></a> */}
                    <a href="https://drive.google.com/file/d/1vMUydiuEGA-jTTs0NLtdCkSC08KldoBu/view?usp=sharing" download> <FontAwesomeIcon icon={faDownload} className="icon yt m-2" />
                    </a>
                </div>
            </header>
        </div>
    )
}

export default HomePage;
